module.exports = __webpack_public_path__ + "img/empty.a09f586b.png";